import React from 'react';
import { useParams } from 'react-router-dom';
import { MemberDetailPanel } from './TeamRoutines';
import '../../styles/Routines.css';

export default function RoutinesHub() {
  const { appId } = useParams();

  return (
    <div className="setup-page">
      <h1 className="page-title">My Routines</h1>
      <p className="page-subtitle">
        Track your recurring role-based activities — daily, weekly, monthly, quarterly, or yearly —
        and see how consistently you're keeping up with them.
      </p>
      <MemberDetailPanel person={null} appId={appId} />
    </div>
  );
}
